export default __webpack_public_path__ + "static/Live-Video_Quicktime-068e2c0e9192863d9b88d085c3a96f82.webp";